/**
 * Search history persisted in localStorage.
 *
 * Storage key:  pinksisly:recent-searches
 * Shape:        string[]   (most-recent first, max 8)
 */

const KEY = 'pinksisly:recent-searches';
const MAX = 8;

function safeParse(json) {
  try {
    const arr = JSON.parse(json);
    return Array.isArray(arr) ? arr.filter((s) => typeof s === 'string') : [];
  } catch {
    return [];
  }
}

export function getRecentSearches() {
  if (typeof window === 'undefined') return [];
  try {
    return safeParse(window.localStorage.getItem(KEY));
  } catch {
    return [];
  }
}

export function addRecentSearch(term) {
  if (typeof window === 'undefined') return [];
  const clean = String(term || '').trim();
  if (!clean) return getRecentSearches();
  const cleanLower = clean.toLowerCase();
  const current = getRecentSearches();
  // Dedup case-insensitively, then prepend
  const filtered = current.filter((s) => s.toLowerCase() !== cleanLower);
  const next = [clean, ...filtered].slice(0, MAX);
  try {
    window.localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // ignore quota errors
  }
  return next;
}

export function clearRecentSearches() {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
